import React, { FC } from 'react';
import classNames from 'classnames';
import styles from './styles.module.css';
import { Body } from '..';

type StalledProps = {
  testId: string;
  className?: string;
};

type StalledContentProps = {
  variant?: 'headline' | 'body';
  className?: string;
};

export const Stalled: FC<StalledProps> = ({ testId, children }) => {
  return <Body data-testid={testId}>{children}</Body>;
};

export const StalledContent: FC<StalledContentProps> = ({
  children,
  className,
  variant = 'body',
}) => {
  return variant === 'headline' ? (
    <h1 className={classNames(styles.headline, className)}>{children}</h1>
  ) : (
    <p className={classNames(styles.body, className)}>{children}</p>
  );
};
